var _defs, _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditcardBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lag_1",
    "data-name": "Lag 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 277.97 323.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#Ikke-navngivet_forl\xF8b_13);}.cls-2{fill:#c6c6c6;}.cls-3{fill:url(#Ikke-navngivet_forl\xF8b_25);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Ikke-navngivet_forl\\xF8b_13",
    x1: 139,
    y1: 6.09,
    x2: 138.96,
    y2: 215.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#eeeeef"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Ikke-navngivet_forl\\xF8b_25",
    cx: 278.58,
    cy: 528.86,
    r: 144.96,
    gradientTransform: "matrix(1.11, 0, 0, 0.03, -170.5, 181.52)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#e9e9e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#efeeee",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#efeeee",
    stopOpacity: 0.97
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#efefef",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#f0efef",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#f1f0f0",
    stopOpacity: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#f2f1f1",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#f3f3f3",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#f4f4f4",
    stopOpacity: 0.21
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#f6f6f6",
    stopOpacity: 0
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 277.97,
    height: 175.98,
    rx: 10.73
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M196.58,411H170.29A6.4,6.4,0,0,1,164,404.5V387.56a6.4,6.4,0,0,1,6.33-6.46h26.29a6.4,6.4,0,0,1,6.33,6.46V404.5A6.4,6.4,0,0,1,196.58,411ZM170.29,381.9a5.61,5.61,0,0,0-5.55,5.66V404.5a5.62,5.62,0,0,0,5.55,5.67h26.29a5.62,5.62,0,0,0,5.55-5.67V387.56a5.61,5.61,0,0,0-5.55-5.66Z",
    transform: "translate(-140.27 -330.96)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M176.47,411a.38.38,0,0,1-.22-.07.4.4,0,0,1-.09-.56l.59-.85a3,3,0,0,0,.11-3.26l-.23-.38a3.77,3.77,0,0,1-.55-2V388.18a3.77,3.77,0,0,1,.55-2l.23-.39a3,3,0,0,0-.11-3.25l-.59-.86a.39.39,0,0,1,.09-.55.38.38,0,0,1,.54.09l.6.86a3.8,3.8,0,0,1,.14,4.13l-.24.38a3,3,0,0,0-.42,1.55v15.69a3,3,0,0,0,.42,1.54l.24.38a3.81,3.81,0,0,1-.14,4.14l-.6.86A.39.39,0,0,1,176.47,411Z",
    transform: "translate(-140.27 -330.96)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M190.24,387.54a.4.4,0,0,1-.38-.27,3,3,0,0,0-.28-.64l-.23-.38a3.8,3.8,0,0,1,.13-4.13l.6-.86a.38.38,0,0,1,.54-.09.39.39,0,0,1,.09.55l-.59.86a3,3,0,0,0-.11,3.25l.23.39a3.87,3.87,0,0,1,.37.8.41.41,0,0,1-.25.5A.25.25,0,0,1,190.24,387.54Z",
    transform: "translate(-140.27 -330.96)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M176.47,392H164.35a.4.4,0,0,1,0-.8h12.12a.4.4,0,0,1,0,.8Z",
    transform: "translate(-140.27 -330.96)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M176.47,400.86H164.35a.4.4,0,0,1,0-.8h12.12a.4.4,0,0,1,0,.8Z",
    transform: "translate(-140.27 -330.96)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M190.4,411a.39.39,0,0,1-.32-.16l-.6-.86a3.81,3.81,0,0,1-.13-4.14l.23-.38a3,3,0,0,0,.43-1.54V392.82a1.62,1.62,0,0,1,1.59-1.64h10.92a.4.4,0,0,1,0,.8H191.6a.83.83,0,0,0-.81.84v11.05a3.77,3.77,0,0,1-.55,2l-.23.38a3,3,0,0,0,.11,3.26l.59.85a.4.4,0,0,1-.09.56A.38.38,0,0,1,190.4,411Z",
    transform: "translate(-140.27 -330.96)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M202.52,400.86H190.4a.4.4,0,0,1,0-.8h12.12a.4.4,0,0,1,0,.8Z",
    transform: "translate(-140.27 -330.96)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 138.98,
    cy: 197.91,
    rx: 138.98,
    ry: 125.13
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditcardBack);
export default __webpack_public_path__ + "static/media/creditcard_back.f885924abf59f60ea7395bc501d93ef4.svg";
export { ForwardRef as ReactComponent };